export default {
  title: "API Errors and Responses",
  subtitle: "Errors",
  path: "errors_section",
  paragraphs: [
    "The API follows a standardized error response format, which may vary slightly depending on the specific route being used.",
    "In general, error responses include an error key along with a code and a descriptive message.",
    "Alternatively, some routes may return only the error key with a list of reasons for the failure."
  ],
  request:  {},
  response: {},
  troubleshooting: {
    title: 'Examples',
    messages: [
      {
        code: {
          "errors": {
            "key_with_error": [
                "Error Message"
            ]
          },
        },
        note: 'This is a error response format, which includes an error key with a list of reasons for the failure.'
      },
       {
        code: {
          "error": "Error message"
        },
        note: 'This is a simplified error response format that may be used in some routes, containing just an error key with a message.'
      }
    ]
  }
}


// WEBPACK FOOTER //
// ./src/components/documentation/data/Errors.js